export const incorrectTypeOfField = (id: string, field: string) =>
	`${id}: Failed to set value of the field '${field}'. Incorrect type.`;
export const fieldCannotBeEmpty = (id: string, field: string) =>
	`${id}: Failed to set value of the field '${field}'. Field cannot be empty.`;
